function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDD05"
    },
    d: "M105.938,350.942c14.578-18.889,32.633-34.958,53.203-47.243c8.548-5.106,17.528-9.563,26.875-13.29 c9.177-3.661,18.707-6.619,28.521-8.818c-23.486-21.657-54.275-33.83-86.64-33.83C57.373,247.761,0,305.135,0,375.657 c0,13.649,11.066,24.715,24.715,24.715H78.43c3.192-8.546,6.979-16.801,11.321-24.715 C94.508,366.983,99.929,358.725,105.938,350.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2FB3B"
    },
    d: "M512,375.657c0-70.521-57.373-127.896-127.896-127.896c-32.365,0-63.153,12.173-86.64,33.83 c9.813,2.2,19.343,5.157,28.521,8.818c9.347,3.729,18.325,8.184,26.873,13.29c20.569,12.285,38.624,28.356,53.203,47.243 c6.007,7.784,11.43,16.042,16.187,24.715c4.342,7.914,8.129,16.168,11.321,24.715h53.717C500.934,400.371,512,389.306,512,375.657z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC27B"
    },
    d: "M171.712,183.951c-4.821-6.778-8.841-14.157-11.932-22.004c-4.608-11.705-7.171-24.435-7.171-37.758 s2.562-26.053,7.172-37.758c3.091-7.849,7.11-15.228,11.931-22.004c-12.283-9.031-27.433-14.382-43.818-14.382 c-40.883,0-74.144,33.261-74.144,74.146c0,40.883,33.261,74.143,74.144,74.143C144.275,198.331,159.427,192.981,171.712,183.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC27B"
    },
    d: "M359.389,124.189c0,13.323-2.562,26.051-7.171,37.758c-3.091,7.848-7.111,15.226-11.932,22.004 c12.285,9.031,27.435,14.381,43.818,14.381c40.885,0,74.144-33.261,74.144-74.143c0-40.885-33.26-74.146-74.144-74.146 c-16.383,0-31.534,5.352-43.818,14.382c4.821,6.778,8.84,14.157,11.931,22.004C356.827,98.136,359.389,110.866,359.389,124.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFC27B"
    },
    d: "M152.609,124.189c0,13.323,2.562,26.051,7.171,37.758c3.091,7.848,7.111,15.226,11.932,22.004 c18.754,26.374,49.533,43.628,84.287,43.628c34.756,0,65.534-17.254,84.287-43.628c4.821-6.778,8.841-14.157,11.932-22.004 c4.608-11.705,7.171-24.435,7.171-37.758s-2.562-26.053-7.171-37.758c-3.091-7.849-7.111-15.228-11.931-22.004 C321.533,38.054,290.753,20.8,256.001,20.8s-65.532,17.254-84.287,43.627c-4.821,6.778-8.84,14.157-11.931,22.004 C155.171,98.136,152.609,110.866,152.609,124.189z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4E276"
    },
    d: "M406.061,350.942c-14.578-18.889-32.633-34.958-53.203-47.243 c-8.548-5.106-17.528-9.561-26.873-13.29c-9.176-3.661-18.707-6.619-28.521-8.818c-13.349-2.992-27.224-4.582-41.465-4.582 s-28.112,1.59-41.465,4.582c-9.812,2.2-19.342,5.157-28.521,8.818c-9.347,3.729-18.325,8.186-26.875,13.29 c-20.569,12.285-38.624,28.354-53.203,47.243c-6.007,7.784-11.43,16.042-16.187,24.715c-4.342,7.914-8.13,16.168-11.321,24.715 c-7.695,20.594-11.911,42.87-11.911,66.115c0,13.649,11.066,24.715,24.715,24.715h329.531c13.649,0,24.715-11.066,24.715-24.715 c0-23.245-4.216-45.52-11.909-66.115c-3.193-8.546-6.979-16.801-11.321-24.715C417.491,366.983,412.07,358.725,406.061,350.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB45C"
    },
    d: "M171.712,64.425c-4.821,6.778-8.84,14.157-11.931,22.004c-4.61,11.705-7.172,24.435-7.172,37.759 c0,13.323,2.562,26.051,7.171,37.758c3.091,7.848,7.111,15.226,11.932,22.004c18.754,26.374,49.533,43.628,84.287,43.628l0,0V20.798 c0,0,0,0-0.002,0C221.245,20.798,190.467,38.053,171.712,64.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64C37D"
    },
    d: "M255.999,277.008c-14.241,0-28.112,1.59-41.465,4.582c-9.812,2.2-19.342,5.157-28.521,8.818 c-9.347,3.729-18.325,8.186-26.873,13.29c-20.569,12.285-38.624,28.354-53.203,47.243c-6.007,7.784-11.43,16.042-16.187,24.715 c-4.342,7.914-8.13,16.168-11.321,24.715c-7.695,20.596-11.911,42.87-11.911,66.115c0,13.649,11.066,24.715,24.715,24.715h164.765 V277.008C256.001,277.008,255.999,277.008,255.999,277.008z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB45C"
    },
    d: "M53.75,124.189c0,40.883,33.26,74.143,74.144,74.143V50.043 C87.011,50.043,53.75,83.304,53.75,124.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECB45C"
    },
    d: "M340.287,64.425c4.821,6.778,8.84,14.157,11.931,22.004c4.61,11.705,7.171,24.435,7.171,37.759 c0,13.323-2.562,26.051-7.171,37.758c-3.091,7.848-7.111,15.226-11.932,22.004c11.698,8.599,26,13.85,41.485,14.333V50.09 C366.285,50.573,351.985,55.824,340.287,64.425z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSvgrepoCom);
export default __webpack_public_path__ + "static/media/group-svgrepo-com.b86d53f3dd035102c5aa777a2f1c2d69.svg";
export { ForwardRef as ReactComponent };